import type { Role } from '@prisma/client';

export const STAFF_ROLES: Role[] = ['ADMIN', 'DIRECTOR'];

export const ROLE_LABELS: Record<Role, string> = {
  DIRECTOR: 'Direktorius',
  ADMIN: 'Administratorius',
  WORKER: 'Darbuotojas',
};

export function isStaffRole(role: string | undefined | null): boolean {
  return role === 'ADMIN' || role === 'DIRECTOR';
}

export function isDirectorRole(role: string | undefined | null): boolean {
  return role === 'DIRECTOR';
}

export function isAdminRole(role: string | undefined | null): boolean {
  return role === 'ADMIN';
}

/** Visi back-office moduliai — administratoriui ir direktoriui vienodai. */
export const STAFF_NAV_HREFS = [
  '/admin-dashboard',
  '/work-acts',
  '/commercial-offers',
  '/task-management',
  '/calendar',
  '/worker-management',
  '/attendance',
  '/history',
  '/objects',
  '/warehouse',
  '/automobiliai',
  '/reports',
  '/other-documents',
  '/settings',
] as const;

/** @deprecated Naudokite STAFF_NAV_HREFS */
export const ADMIN_NAV_HREFS = STAFF_NAV_HREFS;

/** @deprecated Direktoriaus ir admin meniu sutapatinti — palikta suderinamumui. */
export const DIRECTOR_ONLY_HREFS = [] as const;
